<template>
    <div class="create-edit-group">
        <Loader :loading="showLoader" />

        <!-- Top Toolbar -->
        <v-card rounded="xl" elevation="4" class="mx-4 mt-4 mb-4 px-4 py-3"
          style="background: linear-gradient(135deg, #285096 0%, #23A5E6 50%, #59C4FF 100%);">
          <div class="d-flex align-center">
            <v-btn icon variant="text" color="white" size="small" @click="goBack">
              <v-icon size="20">mdi-arrow-left</v-icon>
            </v-btn>
            <div class="ml-3 text-h6 font-weight-semibold" style="color: #ffffff;">
              {{ $t('groups.create-group') }}
            </div>
            <v-spacer />
            <v-btn class="pulse-animation mr-2" variant="tonal" @click="goBack" color="red">
                {{ $t('users.abort') }}
            </v-btn>
            <v-btn size="small" class="pulse-animation" variant="tonal" color="green">
                {{ $t('groups.save') }}
            </v-btn>
            <img :src="logo" class="toolbar-icon-white ml-2" />
          </div>
        </v-card>

        <!-- Group Info Section -->
        <div class="user-section">
            <h2> {{ $t('groups.information') }}</h2>
            <v-row>
                <v-col cols="12">
                    <v-text-field :label="$t('groups.group-name')" v-model="group.name" variant="outlined" />
                </v-col>
                <v-col cols="12">
                    <v-textarea :label="$t('groups.description')" v-model="group.description" variant="outlined"
                        rows="3" />
                </v-col>
            </v-row>
        </div>

        <!-- Group Members Section -->
        <div class="roles-groups-section">
            <h2> {{ $t('groups.members') }}</h2>
            <v-card-text class="tile-description">{{ $t('groups.add-users-description') }}</v-card-text>
            <v-btn color="primary" class="mb-2">{{ $t('groups.add-users-message') }}</v-btn>
            <v-simple-table dense>
                <!-- <thead>
                    <tr>
                        <th>Name</th>
                        <th>E-Mail</th>
                        <th>Firma</th>
                        <th>Optionen</th>
                    </tr>
                </thead> -->
                <tbody>
                    <!-- <tr>
                        <td colspan="4" class="text-center text--disabled">Keine Objekte anzuzeigen</td>
                    </tr> -->
                </tbody>
            </v-simple-table>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Loader from '@/components/general/Loader.vue'
import { getToolbarLogoImage } from '@/assets/Branding/branding.js'

const showLoader = ref(false)
const logo = ref('')
const group = ref({
    name: '',
    fakturiaId: '',
    description: '',
})

const goBack = () => window.history.back()

onMounted(async () => {
    logo.value = await getToolbarLogoImage()
})
</script>

<style scoped>
.create-edit-group {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.toolbar-icon-white {
    height: 30px;
    filter: brightness(0) invert(1);
}

.user-section,
.roles-groups-section {
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fff;
}

h2 {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    color: #333;
}

.tile-description {
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
    color: #666;
}

@media screen and (max-width: 768px) {
    h2 {
        font-size: 1.15rem;
    }

    .create-edit-group {
        padding: 0.5rem;
    }
}
</style>
